module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-kidneyuat-api.rugcc.org/api/v1",
        current_environment : "kidneyuat"
    }
};